import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const HouseKeepingDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="House Keeping"
      sectionId="house-keeping"
      sectionKey="House Keeping"
      description="Housekeeping Supplies & Operations"
      backRoute="/"
    />
  );
};

export default HouseKeepingDashboard;
